import React, { useEffect, useId, useRef } from 'react';
import { Button, IconButton, Box, Typography } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const FileInput = ({
  onFileSelect,
  onFileRemove,
  onFileUpload,
  file,
  setFile,
  accept = 'image/*',
  existingFileUrl,
  chooseButtonSx,
}) => {
  const ref = useRef();
  const inputId = useId();

  useEffect(() => {
    if (!file && !existingFileUrl && ref.current) {
      ref.current.value = '';
    }
  }, [file, existingFileUrl]);

  const displayName = file
    ? file.name
    : existingFileUrl
      ? decodeURIComponent(existingFileUrl.split('/').pop().split('?')[0])
      : null;

  return (
    <Box display="flex" alignItems="center" gap={1.5} sx={{ minWidth: 0, width: '100%' }}>
      <input
        type="file"
        accept={accept}
        ref={ref}
        onChange={onFileSelect}
        style={{ display: 'none' }}
        // id="mui-file-input"
        id={inputId}
      />
      {/* <label htmlFor="mui-file-input"> */}
      <label htmlFor={inputId} style={{ flexShrink: 0 }}>
        <Button variant="contained" component="span" size="small" sx={{ py: 0.5, px: 1.5, ...chooseButtonSx }}>
          Choose File
        </Button>
      </label>

      {displayName && (
        <Box display="flex" alignItems="center" gap={1} sx={{ minWidth: 0, flex: 1 }}>
          <Typography
            variant="body2"
            noWrap
            title={displayName}
            sx={{
              minWidth: 0,
              flex: 1,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              fontSize: '13px',
            }}
          >
            {displayName}
          </Typography>
          <IconButton
            color="error"
            size="small"
            sx={{ flexShrink: 0 }}
            onClick={() => {
              onFileRemove();
              ref.current.value = '';
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
          {onFileUpload && (
            <Button
              variant="outlined"
              size="small"
              sx={{ flexShrink: 0 }}
              onClick={() => {
                onFileUpload();
              }}
            >
              Upload
            </Button>
          )}
        </Box>
      )}
    </Box>
  );
};

export default FileInput;
